import { IFormValues } from '../Goods/interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  cost: '',
  wholesale_cost: '',
  amount: 0,
  eans: [''],
  use_global_discounts: false,
  use_fair_sign: false,
  nds: null,
  comment: '',
  is_excise: false,
  image: '',
  notify_in_telegram: false,
  show_in_shell: false,
  category: null,
  low_stock_notification: {
    enabled: false,
    threshold: 5,
  },
  highlighted: false,
};
